// Check valve vertex schema — dual-junction non-return element. Blocks reverse flow;
// forward loss is a fixed Cv/K (reusing the engine's fixed_flow_coefficient law, pure-Cv);
// a spring cracking pressure (a DELTA, >=0; 0 = pure non-return) gates forward opening — enforced
// in the solver's active-set loop, NOT inside the edge law. Mirrors strainer.ts.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

export const CHECK_VALVE_TYPES = ['swing', 'lift', 'ball'] as const;
export type CheckValveType = (typeof CHECK_VALVE_TYPES)[number];

const CheckValveLossSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('cv'), cv: z.number().positive() }),
  z.object({ mode: z.literal('k'), k: z.number().positive() }),
  z.object({ mode: z.literal('type'), valve_type: z.enum(CHECK_VALVE_TYPES) }),
]);

export const CheckValveVertexSchema = BaseVertexSchema.extend({
  type: z.literal('check_valve'),
  // C++ never emits a check valve (Connect-only); elevations optional, mirroring fixed_loss/strainer.
  inlet_elevation: ValueWithUnitSchema.optional(),
  outlet_elevation: ValueWithUnitSchema.optional(),
  /** Forward-flow loss: Cv (canonical), K, or a valve type (swing/lift/ball → Crane TP-410 K). REQUIRED — never lossless. */
  loss: CheckValveLossSchema,
  /** Spring cracking pressure — forward Δp DELTA needed to open. >=0; 0 = pure non-return. */
  cracking_pressure: ValueWithUnitSchema,
});

export type CheckValveVertex = z.infer<typeof CheckValveVertexSchema>;
